import React from 'react'
import { PostPreviewCard } from '../blog/BlogList'
import { BlogPost } from '../blog/BlogTypes'

interface RelatedPostsList {
  relatedPosts: BlogPost[]
}

export default function RelatedPostsList({
  relatedPosts,
}: RelatedPostsList): JSX.Element {
  return (
    <div className="my-20 mt-40">
      <h1 className="font-medium text-xl mb-6">Similar Articles</h1>

      <div className="space-y-28 md:space-y-0 md:grid grid-cols-3 gap-8">
        {relatedPosts.map((post) => (
          <PostPreviewCard post={post} key={post.slug} />
        ))}
      </div>
    </div>
  )
}
